

















































import Vue from "vue";
import { DataHelper } from "@/helpers/DataHelper";
import Field from "@/components/basic/fields/Field.vue";
import Select from "@/components/basic/fields/Select.vue";
import { mapState } from "vuex";
import { UtilityHelper } from "@/helpers/UtilityHelper";
import i18n from "@/i18n";

export default Vue.extend({
  name: "DateField",
  props: {
    name: String,
    value: {
      type: String || Number,
    },
    label: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      months: [] as object[],
      day: "" as any,
      month: "" as any,
      year: "" as any,
      model: this.value,
      isInputFocused: false,
      isInitialLoad: true,
      TRANSLATION_KEY: "compositeFields.DateField",
    };
  },
  mounted(): void {
    this.fillDate();

    if (this.formDataStore.hasOwnProperty(this.name) && null !== this.formDataStore[this.name]) {
      const value = this.formDataStore[this.name].split("-");

      this.year = value[0] || this.year;
      this.day = value[2] || this.day;

      UtilityHelper.sleep(10).then(() => {
        this.$nextTick(() => {
          this.month = value[1] || this.month;
        
          if (this.model && this.model.length && this.name !== "email") {
            this.$emit("input", `${this.year}-${this.month.padStart(2, "0")}-${this.day.padStart(2, "0")}`);
            this.$emit("blur");
          }
        });
      });
    }

    this.isInitialLoad = false;
    document.addEventListener("click", (evt: MouseEvent) => this.blurFocusOnDateField(evt));
  },
  beforeMount(): void {
    this.loadMonthsTranslations();
  },
  methods: {
    fillDate() {
      const parsedDate = new Date(Date.parse(this.value));
      if (!isNaN(parsedDate.getTime())) {
        this.year = String(parsedDate.getFullYear());
        this.month = String(parsedDate.getMonth() + 1).padStart(2, "0");
        this.day = String(parsedDate.getDate()).padStart(2, "0");
      }
    },
    isLabelShown(): boolean {
      return Boolean(this.day.length || this.month.length || this.year.length || this.isInputFocused);
    },
    setFocusOnDateField(): void {
      if (!this.isInputFocused) {
        this.isInputFocused = true;
      }
    },
    blurFocusOnDateField(evt: MouseEvent): void {
      if (!(evt.target as HTMLElement).closest(".field--date") && this.isInputFocused) {
        this.isInputFocused = false;
      }
    },
    isFilled(): boolean {
      return this.day.length > 0 && this.month.length > 0 && this.year.length > 0;
    },
    onBlur() {
      this.$emit("blur");
    },
    onDayBlur() {
      if (this.isFilled()) {
        this.$emit("blur");
      }
    },
    setDate(value: string | number, arrayElement: number): void {
      const pattern = this.model.split("-");

      pattern[arrayElement] = Number(value) < 10 ? "0" + Number(value) : value.toString();
      this.model = pattern.join("-");

      if (this.isFilled()) {
        this.$emit("input", this.model);
      }
    },
    async loadMonthsTranslations(): Promise<void> {
      Object.entries(await DataHelper.loadJSON(i18n.locale)).forEach(([key, value]) => {
        if (key && key === "months") {
          (this as any).months = value;
        }
      });
    },
  },
  watch: {
    day(value: string) {
      this.setDate(value.replace(new RegExp("-", "g"), ""), 2);
    },

    month(value: any) {
      this.setDate(value.replace(new RegExp("-", "g"), ""), 1);
      if (this.isFilled()) {
        this.$emit("blur");
      }
    },

    year(value: string) {
      this.setDate(value.replace(new RegExp("-", "g"), ""), 0);
    },
  },
  computed: {
    ...mapState({
      formDataStore(): any {
        return this.$store.state.formData;
      },
    }),
  },
  components: {
    Field,
    Select,
  },
});
